import React from 'react';
import WeatherTable from "../components/WeatherTable";


function WeatherPage({wx}) {
    
    return (
        <>
        <article className="App-weather">
        
        <WeatherTable weather={wx}/> 
        </article>

    </>
    );
}
export default WeatherPage;

